import { render, staticRenderFns } from "./VolunteerExperiences.vue?vue&type=template&id=56b30720&scoped=true&"
import script from "./VolunteerExperiences.vue?vue&type=script&lang=js&"
export * from "./VolunteerExperiences.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerExperiences.vue?vue&type=style&index=0&id=56b30720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b30720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
